<template>
  <div class="container">
  <div class="row justify-content-center mt-10">
    <div class=" col-sm-11 col-md-9 col-lg-7 col-xl-6">

      <LogoAuth/>

      <Form class=" mt-10" @submit="userRegister" >

        <Field_l_fe :schema="registerSchema" />

        <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
          {{ message }}
        </div>

        <div class="testEmail" v-if="showConfirm">
          <i>Si no lo recibe, verifique si el mismo se encuentra en la casilla de spam o correo no deseado.</i><br/>
          <i>Si aún asi no lo encuentra, verifique si esta correcta la dirección de Email y vuelva a registrarse.</i><br/>
        </div>

        <Field_l_fe v-if="showConfirm" :schema="tokenSchema" />

        <div v-if="!successful && !showConfirm" class="form-group d-grid"> <!-- d-grid gap-2">-->
          <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-show="loading"  class="spinner-border spinner-border-sm"></span>
              <font-awesome-icon icon="user-plus" />
              Registrarse
          </button>
        </div>
        <div v-if="showConfirm" class="d-flex justify-content-around pb-2 gap-1">
          <div class="col-sm-4 d-grid">
          <button type="submit" class="btn btn-secondary" :disabled="loading">
              <span v-show="loading"  class="spinner-border spinner-border-sm"></span>
              Validar Token
          </button>
          </div>
          <div class="col-sm-8 d-grid">
          <button type="button" class="btn btn-primary" :disabled="loading" v-on:click="registerAgaing">
              <span v-show="loading"  class="spinner-border spinner-border-sm"></span>
              Volver a Registrarse
          </button>
          </div>
        </div>

      </Form>
    </div>
  </div>
  </div>
</template>

<script>
import { Form, defineRule } from "vee-validate";
import { string } from "yup";
import LogoAuth from '../components/LogoAuth.vue';
import Field_l_fe from '../components/Field-l-fe.vue';

defineRule("confirmed", (value, [other]) => {
  if (value !== other) {
    return '¡Las contraseñas no coinciden!';
  }
  return true;
});

export default {
  name: 'Register',
  components: {
    Form,
    LogoAuth,
    Field_l_fe,
  },
  data() {
    return {
      successful: false,
      loading: false,
      message: "",
      showConfirm: false,
      validCode: "",
    };
  },
  computed: {
    registerSchema() {
      let schema = {
        classDivCont: "form-group row mb-1",
        classLabel: "col-sm-4",
        classDivField: "d-flex align-items-end flex-column col-sm-8",
        fields: [
          {
            id: 1,
            label: 'Apellido',
            name: 'lastname',
            type: 'text',
            rules: string().required("¡Se requiere apellido!")
                    .max(30, "¡Debe tener un máximo de 30 caracteres!"),
          },
          {
            id: 2,
            label: 'Nombres',
            name: 'names',
            type: 'text',
            rules: string().required("¡Se requiere nombres!")
                    .max(50, "¡Debe tener un máximo de 50 caracteres!"),
          },
          {
            id: 3,
            label: 'Nombre de Usuario',
            name: 'username',
            type: 'text',
            rules: string().required("¡Se requiere nombre de usuario!")
                    .min(3, "¡Debe tener al menos 3 caracteres!")
                    .max(20, "¡Debe tener un máximo de 20 caracteres!"),
          },
          {
            id: 4,
            label: 'Direccion de Email',
            name: 'email',
            type: 'email',
            rules: string().required("¡Se requiere direccion de Email!")
                    .email("¡Direccion de Email invalida!")
                    .max(50, "¡Debe tener un máximo de 50 caracteres!"),
          },
          {
            id: 5,
            label: 'Contraseña',
            name: 'password',
            type: 'password',
            rules: string().required("¡Se requiere contraseña!")
                    .min(6, "¡Debe tener al menos 6 caracteres!")
                    .max(40, "¡Debe tener un máximo de 40 caracteres!"),
          },
          {
            id: 6,
            label: 'Repetir Contraseña',
            name: 'password2',
            type: 'password',
            rules:'confirmed:@password',
          },
        ],
      };
      return schema;
    },
    tokenSchema() {
      let schema = {
        classDivCont: "form-group row mb-1",
        classLabel: "col-sm-4",
        classDivField: "d-flex align-items-end flex-column col-sm-8",
        fields: [
          {
            id: 1,
            label: 'Token de Validacion',
            name: 'tokenvalid',
            type: 'text',
            rules: string().required("¡Se requiere token de validacion!")
                    .oneOf([this.validCode, null], "¡Token de validacion incorrecto!"),
          },
        ],
      };
      return schema;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.$router.push("/profile");
    }
  },
  methods: {
    registerAgaing:function() {
      this.showConfirm = false;
      this.message = "";
      console.log("reset");
    },
    userRegister(user) {
      //console.log(user.email);
      this.message = "";
      this.successful = false;
      this.loading = true;

      user.confirmok = false;
      if (this.showConfirm && this.validCode == user.tokenvalid)
        user.confirmok = true;
      /*
      console.log(user.tokenvalid);
      console.log(user.confirmok);
      console.log(user.email);
      */
      this.$store.dispatch("auth/register", user).then(
        (data) => {
          this.message = data.message;
          this.successful = true;
          this.loading = false;
          this.showConfirm = false;
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            "Error de sistema (Register): " + error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
          this.showConfirm = false;
          if (this.message.indexOf("400") == -1 && error.response.data.confirmCode.length > 0) {
            //this.message =  this.message + "";  
            this.validCode = error.response.data.confirmCode;
            this.showConfirm = true;
          }
          //console.log(error.response.data.confirmCode.length);
        }
      );
    },
  },
}
</script>

<style>
.alert {
  margin-top: 1rem;
}
.testEmail {
  font-size: x-small;
  padding-bottom: 10px;
}
</style>